const emailRegex = /(.+)@(.+){2,}\.(.+){2,}/;

const emailUtils = {
    isValid: email => emailRegex.test(email),
};

export default emailUtils;
